import { useCallback, useState } from 'react';

/**
 * Independent open/closed state for a set of accordions addressed by a
 * stable string key.
 */
export function useAccordions() {
    const [openKeys, setOpenKeys] = useState<string[]>([]);

    const toggle = useCallback((key: string) => {
        setOpenKeys(prev => prev.includes(key)
            ? prev.filter(item => item !== key)
            : [...prev, key]);
    }, []);

    const isOpen = useCallback(
        (key: string) => openKeys.includes(key),
        [openKeys],
    );

    return { isOpen, toggle };
};
